module.exports = __webpack_public_path__ + "static/media/mini_h5_share_guide.e2646c59.png";